import React, { FC } from "react";

import { useQuery } from "@tanstack/react-query";
import { requests } from "../../services/http-common";
import Layout from "../Layout/Layout";
import LayoutPlaceholder from "../LayoutPlaceholder/LayoutPlaceholder";
import {TPolicyVersion} from "../../@types/global";


interface TAppProps {
  userLogOut: () => void;
  logOutLoading: boolean;
}

const policyVersionInitialData: TPolicyVersion = {
  currentPolicyVersion: '',
  currentTermsVersion: '',
  forceAccept: false,
  userPolicyVersion: '',
  userTermsVersion: '',
}

export const App: FC<TAppProps> = ({ userLogOut, logOutLoading }) => {
  const paramsUrl = window.location.search;
  const params = new URLSearchParams(paramsUrl);
  const companyId = params.get('companyId');

  const { data: userPerCompanyConfig, refetch } = useQuery({
    queryKey: ["general-info"],
    queryFn: async () => {
      return requests.get(`/api/users/info`);
    },
    gcTime: 0,
    // refetchInterval: 120000,
    // refetchOnWindowFocus: true,
  });
  const companies = userPerCompanyConfig?.companies || [];
  const email = userPerCompanyConfig?.email;
  const userId = userPerCompanyConfig?.id;
  const userName = userPerCompanyConfig?.name;
  const policyVersion = userPerCompanyConfig?.policyVersion as TPolicyVersion || policyVersionInitialData;

  const refetchUserPerCompanyConfig = () => {
    refetch();
  }

  if (!userPerCompanyConfig) {
    return (
      <LayoutPlaceholder />
    );
  }
  
  if (companies.length === 0) {
      return (
          <div className="flex align-items-center justify-content-center min-h-screen bg-gray-50">
            <div className="surface-card p-5 shadow-2 border-round text-center">
              <i className="pi pi-lock text-4xl text-red-500 mb-3"></i>
              <h2 className="text-2xl mb-2">Access Denied</h2>
              <p className="text-gray-600 mb-4">
                You are not assigned to any company yet. Please contact your administrator.
              </p>
            </div>
          </div>
      )
  }


if(companyId) {
  sessionStorage.setItem("selectedCompanyId", companyId);
}

  const selectedCompanyId = companyId || sessionStorage.getItem('selectedCompanyId');
  const savedCompanyId =  selectedCompanyId ? Number(selectedCompanyId) : '';
  const defaultCompany = (selectedCompanyId && companies.find((company: any) => company.companyId === savedCompanyId)) || companies[0];

  return (
    <Layout
        defaultCompany={defaultCompany}
        companies={companies}
        email={email}
        userLogOut={userLogOut}
        userName={userName}
        userId={userId}
        logOutLoading={logOutLoading}
        policyVersion={policyVersion}
        refetchUserPerCompanyConfig={refetchUserPerCompanyConfig}
    />
  );
};
